import { Routes, Route } from "react-router-dom";
import Login from './components/auth';
import Dashboard from './components/dashboard';
import NotFound from './components/not-found';
import CollegeDashboard from "./components/college-dashboard";
import UniversityDetails from "./components/university-details";
import TermsAndConditions from "./components/terms-condition";

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/dashboard-admin" element={<Dashboard />} />
        <Route path="/universities-dashboard" element={<CollegeDashboard />} />
        <Route path="/universities/:uid" element={<UniversityDetails />} />
        <Route path="terms" element={<TermsAndConditions />} />

        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
}


export default App;
